import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { ReauthorizeCommand } from './commands/ReauthorizeCommand';
import { AddItemCommand } from './commands/AddItemCommand';
import { BeginPlaceOrderCommand } from './commands/BeginPlaceOrderCommand';
import { PlaceOrderSDKCommand } from './commands/PlaceOrderSDKCommand';
import { AddCouponCommand } from './commands/AddCouponCommand';
import { RemoveCouponCommand } from './commands/RemoveCouponCommand';
import { ReviewViewCommand } from './commands/ReviewViewCommand';
import { ReplaceItemCommand } from './commands/ReplaceItemCommand';
import { UpdateHostAnnotationsCommand } from './commands/UpdateHostAnnotationsCommand';
import { checkoutClient as checkoutSDK, DropInPaymentsCommandNames, SharedCommandNames } from '@chegg/commerce-utils';
import { PaymentTypes } from '@chegg/payment-methods';
import { BilldeskResponseHandlerCommand } from './commands/BilldeskResponseHandlerCommand';
import { InitializeUpiCheckoutCommand } from './commands/InitializeUpiCheckoutCommand';
export var CommandFactory = /*#__PURE__*/function () {
  function CommandFactory() {
    _classCallCheck(this, CommandFactory);
  }
  return _createClass(CommandFactory, null, [{
    key: "createCommand",
    value: function createCommand(commandInput) {
      var commandInputWithSDK = _objectSpread(_objectSpread({}, commandInput), {}, {
        client: checkoutSDK
      });
      var input = commandInputWithSDK.input;

      //Repeated object destructure is as workaround due to typescript being not smart enough to know
      //to classify the key `input` as the correct type based on the switch statement.
      switch (input.commandName) {
        case SharedCommandNames.REAUTHORIZE:
          return new ReauthorizeCommand(_objectSpread(_objectSpread({}, commandInputWithSDK), {}, {
            input: input
          }));
        case DropInPaymentsCommandNames.ADD_ITEM:
          return new AddItemCommand(_objectSpread(_objectSpread({}, commandInputWithSDK), {}, {
            input: input
          }));
        case DropInPaymentsCommandNames.ADD_COUPON:
          return new AddCouponCommand(_objectSpread(_objectSpread({}, commandInputWithSDK), {}, {
            input: input
          }));
        case DropInPaymentsCommandNames.REMOVE_COUPON:
          return new RemoveCouponCommand(_objectSpread(_objectSpread({}, commandInputWithSDK), {}, {
            input: input
          }));
        case DropInPaymentsCommandNames.PLACE_ORDER:
          return new BeginPlaceOrderCommand(_objectSpread(_objectSpread({}, commandInputWithSDK), {}, {
            input: input
          }));
        //This command is not called by the host, it is used internally in response
        //to a FETCH_MOP success.
        case DropInPaymentsCommandNames.PLACE_ORDER_THROUGH_SDK:
          if (
          // @ts-ignore -- see CW-2387 for more context
          commandInput.input.data.mop.accountType === PaymentTypes.PLACEHOLDER ||
          // @ts-ignore -- see CW-2387 for more context
          commandInput.input.data.mop.accountType === PaymentTypes.UPI) {
            return new InitializeUpiCheckoutCommand(_objectSpread(_objectSpread({}, commandInputWithSDK), {}, {
              input: input
            }));
          }
          return new PlaceOrderSDKCommand(_objectSpread(_objectSpread({}, commandInputWithSDK), {}, {
            input: input
          }));
        case DropInPaymentsCommandNames.BILLDESK_RESPONSE_HANDLER:
          return new BilldeskResponseHandlerCommand(_objectSpread(_objectSpread({}, commandInputWithSDK), {}, {
            input: input
          }));
        case DropInPaymentsCommandNames.REVIEW_VIEW:
          return new ReviewViewCommand(_objectSpread(_objectSpread({}, commandInputWithSDK), {}, {
            input: input
          }));
        case DropInPaymentsCommandNames.UPDATE_HOST_ANNOTATIONS:
          return new UpdateHostAnnotationsCommand(_objectSpread(_objectSpread({}, commandInputWithSDK), {}, {
            input: input
          }));
        case DropInPaymentsCommandNames.REPLACE_ITEM:
          return new ReplaceItemCommand(_objectSpread(_objectSpread({}, commandInputWithSDK), {}, {
            input: input
          }));
        default:
          return null;
      }
    }
  }]);
}();


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/commandManager/CommandFactory.js
// module id = 4685
// module chunks = 11